import { Link } from '@tanstack/react-router';
import { ReactNode } from 'react';

import familyDotsLogoSrc from '@/assets/family-dots-long.png';
import { useIsMobile } from '@/shared/hooks/use-mobile';
import { Button } from '@/shared/ui/button';
import { Separator } from '@/shared/ui/separator';
import { SidebarTrigger } from '@/shared/ui/sidebar';

import { useAuth } from './auth-provider';
import { HelpButton } from './help-button';
import { useLanguage } from './language-provider';
import { LanguageSelect } from './language-select';

type BaseHeaderProps = {
  children?: ReactNode;
};

export const BaseHeader = ({ children }: BaseHeaderProps) => {
  const { isGuest } = useAuth();
  const isMobile = useIsMobile();
  const { language, handleLanguageChange } = useLanguage();

  return (
    <header className="flex items-center justify-between border-b-2 px-4 py-6 md:px-10">
      <div>
        <Link to={isGuest ? '.' : '/'}>
          <img
            src={familyDotsLogoSrc}
            alt="Family Dots Logo"
            className="w-[150px] max-w-[150px]"
            width={150}
            height={150}
          />
        </Link>
      </div>

      <div className="flex gap-4">
        {children}

        {!isMobile && (
          <LanguageSelect value={language} onValueChange={handleLanguageChange} />
        )}

        <div>
          <Separator className="invisible md:visible" orientation="vertical" decorative />
        </div>

        <div className="flex gap-2">
          <HelpButton />

          {isMobile && (
            <Button asChild size="icon">
              <SidebarTrigger />
            </Button>
          )}
        </div>
      </div>
    </header>
  );
};

/**
 * Tally Docs: https://tally.so/help/developer-resources#85b0ab91621742cdb600183f9c261fae
 */
